import { Card } from "primereact/card";

const FilterCard = (props: any) => {
  return (
    <Card
      title={props.title}
      className="w-full shadow-none mb-4"
      pt={{
        title: {
          className: "text-base font-bold mb-0",
        },
        body: {
          className: "p-0",
        },
      }}
    >
      {props.children}
    </Card>
  );
};

export default FilterCard;
